import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import GridService from '../../components/tribe/tribe_services'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import Event1 from '../../assets/image/event1.jpg'
import Event2 from '../../assets/image/event2.jpg'
import Event3 from '../../assets/image/event3.jpg'

import Assesment from '../../assets/image/assestment/Assestment.jpg'
import assestment_center from '../../assets/image/assestment/assestment_center.jpg'
import competence from '../../assets/image/assestment/compentence.jpg'
import online_psychologi from '../../assets/image/assestment/online_psychologi.jpg'
import psychologi_test from '../../assets/image/assestment/psychologi_test.jpg'
import virtual from '../../assets/image/assestment/virtual.jpg'
let data_services=[
    {
        title:"Virtual Assessment Center",
        content:"Simulates an online desktop environment, where Participants are presented with a variety of information and business issues.",
        img:virtual,
        link:'/services/assesment/virtualassestmment'
    },
    {
        title:"Psychological Test",
        content:"Psychological test is a set of items designed to measure characteristics of human beings that pertain behavior”.        ",
        img:psychologi_test,
        link:'/services/assesment/psychologi'
    },
    {
        title:"Assessment Center",
        content:"Assessment Center is the method for assessing one’s competence through several behavioral simulations that refers to the competencies needed for …",
        img:assestment_center,
        link:'/services/assesment/center'
    },
    {
        title:"Online Psychological Test",
        content:"Talentlytica Psychograph Analytics is most determined to provide the services related to psychometric analytics best to fit your needs.",
        img:online_psychologi,
        link:'/services/assesment/onlinetest'
    },
    {
        title:"Competency",
        content:"Build & Development of Competency Dictionary Competency is ability to be and the ability to interact with others follow by ability to know and …",
        img:competence,
        link:'/services/assesment/compentency'
    },
]
export default class index extends Component {
    render() {
        const image=[
            {image:Assesment}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='assestment-section'>
                    <Banner bread_crum={['Assessment','']} image={image}   title="Providing Assessment & Talent Management solutions" subtitle="Deliver assessment report as valuable information for the participants and provide development plan for each participant."/>
                    <br/><br/>
                    <div className='assestment-content'>
                        <h2>Our Services</h2>
                        <br/><br/>
                        <GridService data={data_services}/>
                        <br/><br/>
                        <div style={{display:'flex',alignItems:'center',justifyContent:'flex-start'}}>                        
                            <h2>Success story</h2>
                            &nbsp;&nbsp;&nbsp;
                            <div style={{width:1,height:40,backgroundColor:'grey'}}></div>
                            &nbsp;&nbsp;&nbsp;
                            <p>Our success journey</p>
                        </div>
                        <br/><br/>
                        <div className='list-section'>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   <p>We helped one of the biggest insurance company on conducting their competency assessment and mapping employee competency.</p>
                               </div>
                           </div>
                           <br/>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   <p>We helped one of the biggest private bank in Indonesia on conducting their competency assessment, mapping employee competencies.</p>
                               </div>
                           </div>
                           <br/>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   <p>We helped the first private TV Station in Indonesia on conducting their competency assessment and mapping employee competencies to make promotional decisions.</p>
                               </div>
                           </div>
                           <br/>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   
                                   <p>We helped an investing company on conducting their competency assessment and mapping their employee competencies.</p>
                               </div>
                           </div>
                           <br/>
                                                     
                        </div>
                        <br/><br/>
                        <div style={{display:'flex',alignItems:'center',justifyContent:'flex-start'}}>                        
                            <h2>Case Study</h2>
                            &nbsp;&nbsp;&nbsp;
                            <div style={{width:1,height:40,backgroundColor:'grey'}}></div>
                            &nbsp;&nbsp;&nbsp;
                            <p>How we solve problem</p>
                        </div>
                        <br/><br/>
                        <div className='list-section'>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   <b>Employee mapping for companies that provide electricity, steam, and nitrogen in Indonesia.</b>
                                   <br/><br/>
                                   <p>
                                        <b>Challenge :</b><br/>
                                        Required information about the readiness of employees in   carrying   their work and ensured employees able to be   mapped properly regarding their abilities.
                                        <br/><br/>
                                        <b>Solution :</b><br/>
                                        Build a dictionary of technical competencies through workshop for the core team and interview with stakeholders to obtain a clear comprehensive types of competencies
                                   </p>
                               </div>
                           </div>
                           <br/>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   <b>International financial institutions that provide loans to developing countries for capital granting programs.</b>
                                   <br/><br/>
                                   <p>
                                        <b>Challenge :</b><br/>
                                        Requires information about employee readiness in carrying their work and ensuring employees able to place into employee mapped regarding its capabilities.
                                        <br/><br/>
                                        <b>Solution :</b><br/>
                                        Provide participants with a psychological test and assessment center along with a development plan for each employee and also management.

                                   </p>
                               </div>
                           </div>
                           <br/>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   <b>Non-ministerial institutions in Indonesia that incharge in land sector.</b>
                                   <br/><br/>
                                   <p>
                                        <b>Challenge :</b><br/>
                                        Build a dictionary of technical competencies for all positions within the company.
                                        <br/><br/>
                                        <b>Solution :</b><br/>
                                        Build a dictionary of technical competencies through workshop for the core team and interview with stakeholders to obtain a clear comprehensive types of competencies. and selecting using online psychological tests and Virtual Assessment Center (Virtual AC).
                                   </p>
                               </div>
                           </div>
                           <br/>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   <b>Employee mapping for commercial companies with specialization in electricity generation in Indonesia.</b>
                                   <br/><br/>
                                   <p>
                                        <b>Challenge :</b><br/>
                                        Conduct a recruitment process for Experts and Expert Assistants for one of the Ministry’s programs in Indonesia.
                                        <br/><br/>
                                        <b>Solution :</b><br/>
                                        Sourcing prospective candidates from various job portals, and selecting using online psychological tests and Virtual Assessment Center (Virtual AC).
                                   </p>
                               </div>
                           </div>
                           <br/>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   <b>Non-ministerial institutions in Indonesia that incharge in land sector.</b>
                                   <br/><br/>
                                   <p>
                                        <b>Challenge :</b><br/>
                                        Build a dictionary of technical competencies for all positions within the company.
                                        <br/><br/>
                                        <b>Solution :</b><br/>
                                        Build a dictionary of technical competencies through workshop for the core team and interview with stakeholders to obtain a clear comprehensive types of competencies. and selecting using online psychological tests and Virtual Assessment Center (Virtual AC).
                                   </p>
                               </div>
                           </div>
                           <br/>
                                                     
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
